import { render, staticRenderFns } from "./ListUnidades.vue?vue&type=template&id=4a37d94e&"
import script from "./ListUnidades.vue?vue&type=script&lang=js&"
export * from "./ListUnidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports